import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react';
import ConfigurableModal from './ConfigurableModal';
import { arrayIsEmpty } from '../../../../utils/functions';

@inject("store")
@observer
export default class ConfigurableModalContainer extends Component {

    constructor(props) {
        super(props);

        this.modalStore = this.props.store.modalStoreCustom;
    };

    render() {
        if (arrayIsEmpty(this.modalStore.configurableModalArray)) return null;

        return (
            <Fragment>
                {this.modalStore.configurableModalArray.reverse().map((modal, index) => (
                    <Fragment key={index} >
                        <ConfigurableModal modal={modal} />
                    </Fragment>
                ))}
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/modal/components/ConfigurableModalContainer.js